<template>
  <div class="card card-body rounded-top">
    <component-table
      actionsWidth="215px"
      entityType="team"
      addButtonEntityType="club"
      :addButtonEntityId="clubId"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @view="goToProfile($event.id)"
      @add="showAddModal()"
      @edit="showEditModal($event.id)"
      @delete="showDeleteDialog($event.id)"
    />

    <team-modal :show="showModal" :id="idToEdit" :clubId="clubId" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import ComponentTable from '@/components/table/Table';
import TeamModal from '@/components/modals/TeamModal';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS, VIEW_ACTION } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';

// @vuese
// Lista grup treningowych
// @group Sport
export default {
  mixins: [
    listMixin('team', {
      listError: 'messages.team.listError',
      getError: 'messages.team.getError',
      added: 'messages.team.added',
      addError: 'messages.team.addError',
      updated: 'messages.team.updated',
      updateError: 'messages.team.updateError',
      deleteConfirm: 'messages.team.deleteConfirm',
      deleted: 'messages.team.deleted',
      deleteError: 'messages.team.deleteError'
    })
  ],
  components: { ComponentTable, TeamModal },
  data() {
    return {
      clubId: tryParseInt(this.$route.params.clubId),
      columns: [{ name: 'name', displayName: 'columns.name', action: VIEW_ACTION.event }],
      actions: [VIEW_ACTION, ...DEFAULT_TABLE_ACTIONS]
    };
  },

  methods: {
    // Przenosi do profilu grupy treningowej
    goToProfile(teamId) {
      this.$router.push({ name: 'team', params: { ...this.$route.params, teamId } });
    }
  }
};
</script>
